import {jwtDecode} from 'jwt-decode';

export const isTokenExpired = (token) => {
  if (!token) {
    return false;
  }
  
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000);
    const isExpired = decodedToken.exp < currentTime;
    // console.log('Token expiration status:', isExpired);
    return isExpired;
  } catch (error) {
    // console.error('Invalid token format:', error); 
    return false; 
  }
};